import styled from "styled-components";
import {AutoSizer, Table} from "react-virtualized";
import React from "react";

const TableContainer = styled.div`
    flex-grow: 1;
`;

const BorderedTable = styled(Table)`
    .ReactVirtualized__Grid {
        border-top: ${props => props.disableHeader ? "none" : "1px solid #d6d0c8"};
    }
    
    .ReactVirtualized__Grid__innerScrollContainer {
        border-bottom: 1px solid rgba(159, 167, 178, 0.32);
        border-left: ${ props => props.bordered ? "1px solid rgba(159, 167, 178, 0.32)" : "none" };
        border-right: ${ props => props.bordered ?  "1px solid rgba(159, 167, 178, 0.32)" : "none" };
    }
    
    .ReactVirtualized__Table__row {
        border-top: solid 1px rgba(159, 167, 178, 0.32);
        cursor: ${props => props.onRowClick ? "pointer" : "inherit"};
        transition: background-color 0.2s ease;
        
        :first-child {
            border-top: ${props => props.disableHeader ? "solid 1px rgba(159, 167, 178, 0.32)" : "none"};
        }
        
        background-color: white;
        
        :hover {
            background-color: #f5f2f0;
        }
        
        :active {
            background-color: ${props => props.onRowClick ? "#f0ece9" : "#f5f2f0"};
        }
    }
`;

export const VirtualizedTable = (props) => {
    return <TableContainer>
        <AutoSizer>
            {
                ({height, width}) => {
                    // Hack the dimensions so that rows are rendered when running tests
                    const newProps = {
                        ...props,
                        height: height === 0 ? 500 : height,
                        width: width === 0 ? 600 : width
                    };
                    return <BorderedTable {...newProps}/>;
                }
            }
        </AutoSizer>
    </TableContainer>


};